/* MERCADO 2.0 — recently viewed rail (sections/mc2-recently-viewed.liquid). Vanilla, no dependencies.
   The section's inline script has already read the history, recorded the current product, written data-handles and
   reserved the space with skeletons. Here: when the rail comes within 600px of the viewport, fetch one stand-alone
   render of the section per handle (/products/<handle>?section_id=mc2-recently-viewed → that product's mc2-card),
   in parallel, keep the history order, drop products that no longer exist, and swap the cards in. Card buttons work
   through the document-level handlers of assets/mc2-cart.js (add / quick buy). */
(function () {
  'use strict';
  if (window.MC2RecentReady) return;
  window.MC2RecentReady = true;

  function fill(el) {
    if (el._mc2rv) return;
    el._mc2rv = true;
    var handles = (el.getAttribute('data-handles') || '').split(',').filter(Boolean);
    var list = el.querySelector('[data-mc2-rv-list]');
    if (!handles.length || !list) { el.hidden = true; return; }
    var root = el.getAttribute('data-root') || '/';
    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=mc2-recently-viewed', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = '';
      parts.forEach(function (part) {
        if (!part) return;
        var doc = new DOMParser().parseFromString(part, 'text/html');
        var li = doc.querySelector('[data-mc2-rv-item]');
        if (li) html += li.outerHTML;
      });
      if (!document.contains(el)) return;
      if (!html) { el.hidden = true; return; }
      list.innerHTML = html;
      el.classList.add('is-ready');
      document.dispatchEvent(new CustomEvent('mc2:rv:ready', { detail: { section: el } }));
    });
  }

  function watch(el) {
    if (el._mc2rvWatch || !el.getAttribute('data-handles')) return;
    el._mc2rvWatch = true;
    if (!('IntersectionObserver' in window)) { fill(el); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.disconnect(); fill(el); }
      });
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mc2-rv]').forEach(watch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
